const Toggle = ({ label, checked, onChange }) => (
    <label className="toggle">
        <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
        />
        <span className="toggle-label">{label}</span>
    </label>
);

export default Toggle;
